import { defineComponent as _defineComponent } from 'vue';
import { ref } from "vue";
import CarbonEmissionsIcon from "./CarbonEmissionsIcon.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CarbonEmissionCard',
    props: {
        heading: null,
        explanation: null,
        value: null,
        icon: null
    },
    setup(__props) {
        const props = __props;
        const shouldShowInfo = ref(false);
        function toggleInfo() {
            shouldShowInfo.value = !shouldShowInfo.value;
        }
        return { __sfc: true, props, shouldShowInfo, toggleInfo, CarbonEmissionsIcon };
    }
});
